import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Modal,
  Grid,
  Stack,
  Pagination,
  Checkbox,
  Card,
  CardContent,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useRef, useState } from "react";

import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

import { useSelector } from "react-redux";

// import DatePicker from "react-datepicker";
import EventIcon from "@mui/icons-material/Event";
import SearchIcon from "@mui/icons-material/Search";
import {
  AddCashPayment,
  getCounterSalesCustomers,
  getUnpaidUser,
} from "./paymentReceiptApi";
import UserCard from "./userCard";
import Swal from "sweetalert2";
import { displayDateFormat, swalAlertPopProps } from "../../utils/commonUtils";
import { validationAdd } from "./paymentReceiptValidations";
import { searchedElementDisplay } from "./receiptFunctions";
import { monthInText } from "./paymentReceiptDateFunction";
import { ModalHeader } from "../../common/modalHeader";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

export default function AddReceipt({
  open,
  setOpen,
  getRecept,
  unPaidBill,
  setUnPaidBill,
  upPaidBillData,
  setUnPaidBillData,
  recepts,
  billData,
  setBillData,
  searchModal,
  setSearchModal,
}) {
  const [pagination, setPagination] = useState({ page: 1, total: 10 });
  const [search, setSearch] = useState("");
  // const [upPaidBillData, setUnPaidBillData] = useState();

  const data = {
    customerMobile: "",
    amount: "",
    paymentMode: "cash",
  };
  const { userDetail } = useSelector((state) => state.reducer);

  const onClose = () => {
    setOpen(false);
  };
  const handleChange = (event, value) => {
    setPagination({
      ...pagination,
      page: value,
    });
  };
  const sumation = (arr) => {
    let val = 0;
    arr?.forEach((ele, index) => {
      val += ele.balanceAmount ?? 0;
    });
    return val;
  };
  // useEffect(() => {
  //   console.log("upPaidBillData ===", upPaidBillData)
  //   const upPaidBillDataCopy = [...upPaidBillData, {
  //     "id": 19525,
  //     "headerRecordId": 19525,
  //     "date": "2025-06-27T18:26:12.5666667",
  //     "billerId": 2,
  //     "billNumber": "2",
  //     "netAmount": 143.00,
  //     "status": "Unpaid",
  //     "balanceAmount": 143.00,
  //     "gst": 0.00,
  //     "buyerInfoId": null,
  //     "buyerId": 0,
  //     "billingMonth": 0,
  //     "billingYear": 0,
  //     "previousMonthBalance": null,
  //     "nextMonthAdvance": 0,
  //     "availableAdvance": 0,
  //     "adjustedAmount": 0
  //   }
  //   ]

  //   // console.log(suma)

  // }, [upPaidBillData])
  const getCounterSalesCusomter = async (param) => {
    await getCounterSalesCustomers(param).then((res) => {
      console.log("countersales res data   ", res?.data?.data, " ", {
        page: res.data.pageNumber,
        total: res.data.totalPages,
      });
      setPagination({
        page: res.data.pageNumber,
        total: res.data.totalPages,
      });
      setUnPaidBill([...res?.data?.data]);
    });
  };

  const addBill = async (param) => {
    await AddCashPayment(param)
      .then((res) => {
        console.log("add Bill ", res?.data?.succeeded);
        if (res?.data?.succeeded) {
          getRecept();
          if (typeof window.refreshOutstandingReport === "function") {
          window.refreshOutstandingReport();
        }
          Swal.fire({
            text: "Saved Record",
            icon: "success",

            ...swalAlertPopProps,
          });
        } else {
          Swal.fire({
            text: res?.data?.message,
            icon: "error",

            ...swalAlertPopProps,
          });
        }
      })
      .catch((err) => {
        console.log("err ", err);
      });
  };
  useEffect(() => {
    if (open === true) {
      getCounterSalesCusomter({
        filter: "",
        search: "",
        page: 1,
        pageSize: 1000,
      });
      setBillData({ ...billData, mybusinessId: userDetail?.myBusinessId });

      const today = dayjs();
      setDate(today.format("DD-MM-YYYY"));
      setStartDate(today.format("YYYY-MM-DD"));
    } else {
      console.log("close");
      setBillData(data);
      setUnPaidBillData([]);
    }
  }, [open]);
  const addLeadingZero = (value) => {
    return value < 10 ? "0" + value : value;
  };
  const [date, setDate] = useState(dayjs().format("DD-MM-YYYY"));
  const [startDate, setStartDate] = useState(dayjs().format("YYYY-MM-DD"));
  const datePickerRef = useRef();

  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };
  useEffect(() => {
    console.log("billData ", billData);
  }, [billData]);
  // const [status, setStatus] = useState("all");

  useEffect(() => {
    if (billData?.name && !billData?.paymentMode) {
      setBillData((prev) => ({ ...prev, paymentMode: "cash" }));
    }
  }, [billData?.name]);
  const selectedCustomerReceipts = recepts?.filter(
    (r) => r?.customerMobile === billData?.mobile
  );
  return (
    <Modal
      open={open}
      onClose={onClose}
      fullWidth={true}
      maxWidth="xs"
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          width: { xs: "95%", sm: "85%", md: "70%", lg: "60%", xl: "50%" },

          overflowY: "auto",
          height: { xs: "96vh", sm: "80vh", md: "81vh" },
          position: "absolute",
          borderRadius: "10px",
          left: { xs: "2%", sm: "5%", md: "10%", lg: "15%", xl: "20%" },

          top: { md: "12%", xs: "1%", sm: "10%" },
        }}
      >
        <ModalHeader
          title="Payment Receipt"
          onClose={(data) => {
            setOpen(data);
          }}
        />

        <Grid container sx={{ position: "relative" }}>
          <Grid item xs={12} sx={{ borderRight: "1px solid #dfdfdf" }}>
            <DialogContent
              sx={{ padding: "10px 20px", borderBottom: "2px solid #01008B" }}
            >
              <Grid container spacing={1}>
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{
                      mt: 1,
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      color: "#545454",
                    }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={date ? dayjs(date, "DD-MM-YYYY") : null}
                        onChange={(newValue) => {
                          setDate(newValue.format("DD-MM-YYYY"));
                          setStartDate(newValue.format("YYYY-MM-DD"));
                        }}
                        format="DD-MM-YYYY"
                        error={!date}
                        slots={{ openPickerIcon: CalendarMonthIcon }}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            label: "Date",
                            size: "small",
                            InputProps: {
                              sx: {
                                background: "#fff",
                                borderRadius: 1,

                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                              },
                            },
                          },
                          openPickerIcon: {
                            sx: { color: "#000" },
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box
                    onClick={() => {
                      setSearchModal(true);
                    }}
                    sx={{
                      display: "flex",
                      height: "20px",
                      justifyContent: "space-between",
                      border: "2px solid #01008BA8",
                      p: 1,
                      fontFamily: "Montserrat",
                      mt: { md: 2, xs: 1 },
                      borderRadius: "4px ",
                      color: "#545454",
                      "&:hover": {
                        cursor: "pointer !important",
                      },
                    }}
                  >
                    <Typography
                      variant="p"
                      sx={{
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      }}
                    >
                      {console.log(billData.name, "billData.name")}
                      {billData.name !== undefined
                        ? billData.name
                        : "Select Customer"}
                    </Typography>
                    <SearchIcon
                      onClick={() => {
                        setSearchModal(true);
                      }}
                      sx={{
                        color: (theme) => theme.palette.primary.main,
                        cursor: "pointer",
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      color: "#545454",
                    }}
                  >
                    <TextField
                      fullWidth
                      size="small"
                      id="receiveAmount"
                      label="Mobile No."
                      value={billData?.mobile !== 0 ? billData?.mobile : ""}
                      onChange={(e) => {
                        let val = e.target.value
                          .replace(/[^\d.]+/g, "")
                          .replace(/\.(?=.*\.)/g, "");
                        // let val = e.target.value;
                        val = val.replace(/\D/g, "");
                        if (upPaidBillData?.balancemobile >= val) {
                          setBillData({
                            ...billData,
                            mobile: val,
                          });
                        }
                      }}
                      // sx={{color: "#545454",}}
                      InputProps={{
                        style: {
                          sx: {
                            color: "#545454",
                            fontWeight: 400,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            paddingX: "7px",
                          },
                          height: "40px",
                          // background:"yellow"
                        },
                      }}
                      InputLabelProps={{
                        shrink: !!billData?.mobile,
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      color: "#545454",
                    }}
                  >
                    <TextField
                      fullWidth
                      size="small"
                      id="receiveAmount"
                      label="Received Amount"
                      value={billData?.amount !== null ? billData?.amount : ""}
                      // type="number"
                      onChange={(e) => {
                        let val = e.target.value;
                        val = val.replace(/[^0-9.]/g, "");
                        val = val.replace(/(\..*)\./g, "$1");
                        //   .replace(/[^\d.]+/g, "")
                        //   .replace(/\.(?=.*\.)/g, "");
                        // // let val = e.target.value;
                        // val = val.replace(/\D/g, "");
                        // if (upPaidBillData?.balanceAmount >= Number(val)) {
                        setBillData({
                          ...billData,
                          amount: val,
                        });
                        // }
                      }}
                      // sx={{color: "#545454",}}
                      InputProps={{
                        style: {
                          height: "40px",
                          // background:"yellow"
                        },
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                      InputLabelProps={{
                        shrink:
                          billData?.amount !== "" && billData?.amount !== 0,
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>
              <Box display="flex" justifyContent="center" mt={1}>
                <RadioGroup
                  row
                  sx={{
                    flexDirection: {
                      xs: "row", // horizontal on mobile
                      sm: "row", // keep horizontal on larger screens too
                    },
                    justifyContent: "center",
                  }}
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  // value={bill.paymentMode}
                  value={billData?.paymentMode}
                  onChange={(e) => {
                    setBillData({ ...billData, paymentMode: e.target.value });
                  }}
                >
                  <FormControlLabel
                    // sx={{ color: (theme) => theme.palette.primary.main }}
                    value="cash"
                    control={<Radio color="primary" />}
                    label="Cash Payment"
                    sx={{
                      ".MuiFormControlLabel-label": {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        px: "7px",
                        fontFamily: "Mulish",
                      },
                    }}
                  />
                  <FormControlLabel
                    color="primary"
                    value="online"
                    // sx={{ color: (theme) => theme.palette.primary.main }}
                    control={<Radio color="primary" />}
                    label="Online Payment"
                    sx={{
                      ".MuiFormControlLabel-label": {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        px: "7px",
                        fontFamily: "Mulish",
                      },
                    }}
                  />
                </RadioGroup>
              </Box>
            </DialogContent>
          </Grid>
          <Grid container sx={{ paddingX: 2, paddingY: 1 }}>
            <Grid item xs={4}>
              <Typography
                sx={{
                  color: "#01008B",
                  fontWeight: 500,
                  fontSize: {
                    xs: "12px",
                    sm: "13px",
                    md: "15px",
                  },
                  fontFamily: "'Montserrat', sans-serif",
                  marginLeft: { sm: "45px", xs: "10px" },
                }}
              >
                Bill Number
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                sx={{
                  color: "#01008B",
                  fontWeight: 500,
                  fontSize: {
                    xs: "12px",
                    sm: "13px",
                    md: "15px",
                  },
                  fontFamily: "'Montserrat', sans-serif",
                  textAlign: "center",
                }}
              >
                Date
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                sx={{
                  color: "#01008B",
                  fontWeight: 500,
                  fontSize: {
                    xs: "12px",
                    sm: "13px",
                    md: "15px",
                  },
                  fontFamily: "'Montserrat', sans-serif",
                  textAlign: "center",
                }}
              >
                Total(₹)
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} sx={{ pr: 2 }}>
            <Box
              sx={{
                height: "30vh",
                overflowY: "auto",
              }}
            >
              {/* Header (already above) stays the same */}
              {upPaidBillData &&
                (upPaidBillData ?? [])?.map((receipt, index) => (
                  <>
                    <Card
                      sx={{
                        width: "100%",
                        m: "0px",
                        mt: "10px",
                        p: "0px",
                        boxShadow: "none",
                      }}
                      //   onClick={callBack}
                      //   onClick={setEditedItem}
                    >
                      <CardContent
                        sx={{
                          p: "0px !important",
                          borderBottom: "1px solid #7D7D7D",
                        }}
                      >
                        <Grid container alignItems="center" sx={{ py: 0.5 }}>
                          <Grid
                            alignItems="center"
                            // justifyContent="center"
                            sx={{ display: "flex", pl: 3 }}
                            item
                            xs={4}
                          >
                            <Checkbox
                              color="primary"
                              checked={true}
                              sx={{ p: 0, mr: 2 }}
                            />
                            <Typography
                              sx={{
                                fontSize: "14px",
                                fontWeight: 500,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {receipt?.billNumber}
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={4}
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              sx={{ fontSize: "14px", fontWeight: 500 }}
                            >
                              {monthInText(receipt?.date?.split("T")[0])}
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={4}
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              pr: 5,
                            }}
                          >
                            <CurrencyRupeeIcon
                              sx={{ fontSize: "12px", mr: 1 }}
                            />
                            <Typography
                              sx={{ fontSize: "12px", fontWeight: 500 }}
                            >
                              {receipt?.balanceAmount}
                            </Typography>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                    {/* <Box> */}
                  </>
                ))}
            </Box>
            {/* <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                paddingX: "30px",
                paddingTop: "10px",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 500,
                  fontFamily: "'Montserrat', sans-serif",
                  marginLeft: "45px",
                }}
              >
                Total Amount: &nbsp;
              </Typography>
              <Box
                component="span"
                sx={{
                  fontWeight: 700,
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: "18px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <CurrencyRupeeIcon sx={{ fontSize: "16px", fontWeight: 700 }} />
                {(function () {
                  let arr = upPaidBillData ? [...upPaidBillData] : [];
                  let add = 0;
                  arr.forEach((ele) => {
                    add += ele.balanceAmount;
                  });
                  return add;
                })()}
              </Box>
            </Box> */}
            <Divider
              sx={{
                background: (theme) => theme.palette.primary.main,
                width: "100%",
                mt: 1,
              }}
            />
            <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
              {" "}
              {/* <Button onClick={onClose}>Cancel</Button> */}
              <Button
                variant="contained"
                sx={{ width: "50%" }}
                onClick={() => {
                  setOpen(false);
                  console.log(
                    "billData =@@@ ",
                    billData,
                    " ****",
                    upPaidBillData[0]
                  );
                  const valid = validationAdd(billData, upPaidBillData[0]);
                  // console.log("billData = ",
                  // return;
                  if (valid.status) {
                    addBill({
                      customer: billData?.customer,
                      customerMobile: billData?.customerMobile,
                      amount: parseFloat(billData?.amount),
                      isCounterSalesBill: true,
                      paymentMode: billData?.paymentMode,
                    });
                  } else {
                    Swal.fire({
                      text: valid.msg,
                      ...swalAlertPopProps,
                      icon: "warning",
                    });
                  }
                }}
              >
                Save
              </Button>
            </DialogActions>
          </Grid>
        </Grid>
        {/* <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            borderTop: "2px solid #01008B",
          }}
        >
          <Button
            variant="contained"
            fullWidth
            sx={{ width: "60%" }}
            onClick={() => {
              setOpen(false);
              const valid = validationAdd(billData, upPaidBillData);
              if (valid.status) {
                addBill({
                  customer: billData?.customer,
                  customerMobile: billData?.customerMobile,
                  amount: parseInt(billData?.amount),
                  isCounterSalesBill: true,
                  paymentMode: billData?.paymentMode,
                });
              } else {
                Swal.fire({
                  text: valid.msg,

                  ...swalAlertPopProps,
                  icon: "warning",
                });
              }
            }}
          >
            Save
          </Button>
        </DialogActions> */}
      </Box>
    </Modal>
  );
}
